import { createSlice } from "@reduxjs/toolkit";

const PledgeReducer = createSlice({
    name: "PledgeReducer",
    initialState: {
        loading: false,
        organizationsLoading: false,
        error: false,
        success: false,
        donations: [],
        redemptions: [],
        organizations: []
    },
    reducers: {
        getDonations: (state) => {
            // state.loading = true;
        },
        getDonationsSuccess: (state, { payload }) => {
            // state.loading = false;
            state.donations = payload?.donations || [];
            state.redemptions = payload?.redeemings || [];
            state.success = true;
            state.error = false;
        },
        getDonationsError: (state, { payload }) => {
            // state.loading = false;
            state.donations = [];
            state.success = false;
            state.error = payload;
        },
        getOraganizations: (state) => {
            state.organizationsLoading = true;
        },
        getOraganizationsSuccess: (state, { payload }) => {
            state.organizationsLoading = false;
            state.organizations = payload?.organizations?.results || [];
            state.success = true;
            state.error = false;
        },
        getOraganizationsError: (state, { payload }) => {
            state.organizationsLoading = false;
            state.organizations = [];
            state.success = false;
            state.error = payload;
        },
        addOrganization: (state) => {
            state.loading = true;
        },
        addOrganizationSuccess: (state) => {
            state.loading = false;
            state.success = true;
            state.error = false;
        },
        addOrganizationError: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.error = payload;
        },
        donate: (state) => {
            state.loading = true;
        },
        donationsSuccess: (state) => {
            state.loading = false;
            state.success = true;
            state.error = false;
        },
        donationsError: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            state.error = payload;
        },
    },
});

export const {
    getDonations,
    getDonationsSuccess,
    getDonationsError,
    getOraganizations,
    getOraganizationsSuccess,
    getOraganizationsError,
    addOrganization,
    addOrganizationSuccess,
    addOrganizationError,
    donate,
    donationsSuccess,
    donationsError
} = PledgeReducer.actions;

export default PledgeReducer.reducer;
